import { useEffect, useState } from "react";
import { listDataDeletionRequests } from "../services/api";

export const DELETION_REQUESTS_CHANGED = "deletion-requests-changed";

export default function usePendingDeletionRequests(accessToken, pathname) {
    const [state, setState] = useState({ token: null, count: 0, error: false });

    useEffect(() => {
        if (!accessToken) return;
        let active = true;
        let loading = false;
        const refresh = async () => {
            if (loading) return;
            loading = true;
            try {
                const response = await listDataDeletionRequests({
                    status: "pending", limit: 1, accessToken,
                });
                if (active) setState({ token: accessToken, count: response.total || 0, error: false });
            } catch {
                if (active) setState({ token: accessToken, count: 0, error: true });
            } finally {
                loading = false;
            }
        };
        refresh();
        const interval = window.setInterval(refresh, 60000);
        window.addEventListener("focus", refresh);
        window.addEventListener(DELETION_REQUESTS_CHANGED, refresh);
        return () => {
            active = false;
            window.clearInterval(interval);
            window.removeEventListener("focus", refresh);
            window.removeEventListener(DELETION_REQUESTS_CHANGED, refresh);
        };
    }, [accessToken, pathname]);

    return accessToken && state.token === accessToken
        ? state : { count: 0, error: false };
}
